<template>
  <div class="redesign-root">
    <div class="screen-card">
      <main class="body-wrap">
        <router-view />
      </main>

      <footer class="brand-footer">
        <img
          src="@/assets/images/trendlife-wordmark.svg"
          alt="TrendLife"
          width="110"
          height="20"
        />
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RedesignLayout',
};
</script>

<style lang="sass" scoped>
.redesign-root
  min-height: 100vh
  min-height: 100dvh
  background: var(--bg, #FEFAF3)
  display: flex
  flex-direction: column
  font-family: var(--font, system-ui, -apple-system, sans-serif)

  @media (min-width: 480px)
    background: var(--surface-warm, #F6EFE8)
    align-items: center
    justify-content: flex-start
    padding: 48px 24px

.screen-card
  width: 100%
  max-width: 480px
  min-height: 100vh
  min-height: 100dvh
  background: var(--bg, #FEFAF3)
  display: flex
  flex-direction: column

  @media (min-width: 480px)
    min-height: 520px
    border-radius: 20px
    box-shadow: 0 8px 48px rgba(0, 0, 0, 0.10), 0 2px 8px rgba(0, 0, 0, 0.06)

.body-wrap
  flex: 1
  padding: 48px 32px 40px
  display: flex
  flex-direction: column

.brand-footer
  padding: 24px 0
  display: flex
  justify-content: center
</style>
